/**
 * Add to calendar
 *
 * @author Marcus Williams
 * @package Joi Polloi
 *
 */
import * as Add2Calendar from 'add2calendar';
import { parse } from 'date-fns';

const addToCalendar = () => {
    const buttons = document.querySelectorAll('.add-to-calendar');
    buttons.forEach(button => {
        const date = parse(button.dataset.date, 'dd/MM/yyyy H:mm', new Date());
        const eventArgs = {
            title: button.dataset.title,
            start: date,
            end: date,
            location: button.dataset.location,
        };
        const singleEvent = new Add2Calendar(eventArgs);
        singleEvent.createWidget(`#${button.dataset.id}`);
        button.addEventListener('click', () => {
            if (singleEvent.eButton.parentElement.classList.contains('active')) {
                singleEvent.eButton.innerText = 'Close';
            } else {
                singleEvent.eButton.innerText = 'Add to calendar';
            }
        });
    });
};
export default addToCalendar;
